/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Prefix_LabelInputs */



/**
* | output |
* | --- |
* | "Prefix Character" |
*
* @param {Insert_Speaker_Prefix_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_prefix_label = /** @type {((inputs?: Insert_Speaker_Prefix_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Prefix_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Caractère de préfixe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Präfixzeichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carattere prefisso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Префиксный символ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carácter de prefijo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("前缀字符")
	if (locale === "ja") return /** @type {LocalizedString} */ ("接頭辞文字")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपसर्ग वर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Caractere de prefixo")
	return /** @type {LocalizedString} */ ("Prefix Character")
});